import Search from './Search.react'

export default Search